module.exports = __webpack_public_path__ + "img/219.clean_surface.1119d35b.svg";